import { Request } from '../../httpClient/serverApi/requests/Request';
import { IAdminProfile } from '../models/IAdminProfile';

export interface IGetServerAdminProfilesParams {
}

export interface IGetServerAdminProfilesResult {
  adminProfiles: IAdminProfile[];
}

export class GetServerAdminProfilesRequest extends Request<IGetServerAdminProfilesParams, IGetServerAdminProfilesResult> {
  constructor(params: IGetServerAdminProfilesParams) {
    super('getServerAdminProfiles', params);
  }
}